export function isChainNameValid(name: string): boolean {
  return name.trim().length > 0
  && name.length <= 50
  && !name.includes("\n");
}
